import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StringUtilsService } from 'app/shared/string-utils.service';
import { WP_API_CURSOS_POS_GRADUACAO, WP_API_CURSOS_POS_GRADUACAO_V2_CEUMA, WP_API_CURSOS_POS_GRADUACAO_V2_EURO } from 'app/config';
import { environment } from 'environments/environment';

export const URL_POSGRADUACAO = WP_API_CURSOS_POS_GRADUACAO + `/cursosposgraduacao/especializacao/`;

@Injectable()
export class EspecializacaoService {

    constructor(private http: HttpClient, private stringUtils: StringUtilsService){}

    listCursoEspecializacao(){
        return this.http
            .get<any>(URL_POSGRADUACAO)
    }

    listCursoEspecializacaoId(id){
      if(environment.loginContexto == 'EURO') {
        return this.http
            .get<any>(WP_API_CURSOS_POS_GRADUACAO_V2_EURO + `/${id}`)
      } else if (environment.loginContexto == 'CEUMA') {
        return this.http
            .get<any>(WP_API_CURSOS_POS_GRADUACAO_V2_CEUMA + `${id}`)
      }
    }

    listCursoName(id: string): Promise<any>{
        return new Promise<any>((resolve, reject) => {
            this.http.get<any>(URL_POSGRADUACAO+`${id}`).subscribe(slugEdital => {
                let slug = this.stringUtils.textoParaSlug(slugEdital.cursosposgraduacao[0].titulo);
                resolve(slug);
            },
            err => {
              reject(err);
            });
        });
    }
}
